import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useLimpieza} from '../../../../../hooks/useLimpieza'
import {ResizeHandle} from '../../../../limpieza/components/Layout/Container/ResizeHandle/ResizeHandle'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {SearchAssigmentModel} from '../../../model/assigment.model'
import {yupResolver} from '@hookform/resolvers/yup'
import {newAssignmentCellphoneSchema} from '../../../../../util/validationLimpieza'
import {AssigmentProvider, useAssigment} from '../../../hooks/limpieza/useAssigment'
import {CellphoneDto} from '../../../model/creationCellphones.model'
import {CleaningActivitiesDto} from '../../../model/creationCleaningActivities.model'

const AssignmentCellphonePage: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useLimpieza()
  const {getActividadesDisponibles, getCelularesDisponibles, getLayout, setSelectedPhonesFn} =
    useAssigment()

  const methods = useForm<SearchAssigmentModel>({
    resolver: yupResolver(newAssignmentCellphoneSchema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      TipoData: '',
      TipoEdificacionId: '',
      CamaId: '',
      CampamentoId: '',
      HabitacionId: '',
      ModuloId: '',
      PisoId: '',
      CompaniaNombre: '',
      ClienteNombre: '',
      SiteNombre: '',
      TipoEdificacionNombre: '',
      CampamentoNombre: '',
      ModuloNombre: '',
      PisoNombre: '',
      HabitacionNombre: '',
      CamaNombre: '',
      EsAsignado: false,
    },
  })

  const handleAssigmentData = async (data: SearchAssigmentModel) => {
    data.TipoData = 'CAP'

    methods.setValue('CompaniaIdCurrent', data.CompaniaId)
    methods.setValue('ClienteIdCurrent', data.ClienteId)
    methods.setValue('SiteIdCurrent', data.SiteId)
    methods.setValue('TipoEdificacionIdCurrent', data.TipoEdificacionId)

    var requestLayout: SearchAssigmentModel = {
      CompaniaId: data.CompaniaId,
      ClienteId: data.ClienteId,
      SiteId: data.SiteId,
      TipoData: data.TipoData,
      TipoEdificacionId: data.TipoEdificacionId,
    }
    setSelectedPhonesFn([])
    await getLayout(requestLayout)

    // var requestCelular: CellphoneDto = {
    //   pageNumber: 1,
    //   size: 1000,
    //   CompaniaId: data.CompaniaId,
    //   ClienteId: data.ClienteId,
    //   SiteId: data.SiteId,
    //   NivelAsignacion: '',
    //   EsAsignado: false,
    // }
    // await getCelularesDisponibles(requestCelular)

    // var requestActividad: CleaningActivitiesDto = {
    //   pageNumber: 1,
    //   size: 1000,
    //   CompaniaId: data.CompaniaId,
    //   ClienteId: data.ClienteId,
    //   SiteId: data.SiteId,
    // }
    // await getActividadesDisponibles(requestActividad)
  }

  const onSubmit = async (data: SearchAssigmentModel) => {
    await handleAssigmentData(data)
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ButtonWrapper>
          <Button label='Buscar' classNameProp='ms-auto' typeBtn='submit' />
        </ButtonWrapper>
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-limpieza-header-${currentTabItem.id}`}
              id={`panel-limpieza-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-limpieza-detail-${currentTabItem.id}`}
                    id={`panel-limpieza-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

const AssignmentCellphonePageWrapper: FC = () => {
  return (
    <AssigmentProvider>
      <AssignmentCellphonePage></AssignmentCellphonePage>
    </AssigmentProvider>
  )
}

export default AssignmentCellphonePageWrapper
